// JsFromRoutes CacheKey fa2f1316bb41f68b9a789daee2649574
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/consumer/omni_search/:searchable_type/:searchable_id'),
  emptyState: /* #__PURE__ */ definePathHelper('get', '/consumer/omni_search/empty_state'),
  index: /* #__PURE__ */ definePathHelper('get', '/consumer/omni_search'),
}
